import {
	parseStoreRules,
	STORE_RULES_KEY,
	type StoreCategoryRules,
} from "@sobidogam/domain";

/**
 * Small per-device preferences kept beside the local records. Every read and
 * write is guarded: a blocked localStorage must never block recording.
 */
export function readPref(key: string): string | null {
	try {
		return window.localStorage.getItem(key);
	} catch {
		return null;
	}
}

export function writePref(key: string, value: string | null): boolean {
	try {
		if (value === null) window.localStorage.removeItem(key);
		else window.localStorage.setItem(key, value);
		return true;
	} catch {
		return false;
	}
}

export function readJsonPref<T>(key: string, fallback: T): T {
	const raw = readPref(key);
	if (!raw) return fallback;
	try {
		return JSON.parse(raw) as T;
	} catch {
		return fallback;
	}
}

export function writeJsonPref(key: string, value: unknown): boolean {
	return writePref(key, JSON.stringify(value));
}

export function readStoreRules(): StoreCategoryRules {
	return parseStoreRules(readPref(STORE_RULES_KEY));
}

export function writeStoreRules(rules: StoreCategoryRules): boolean {
	return writeJsonPref(STORE_RULES_KEY, rules);
}

export function monthStartDayPref(): number {
	const value = Number(readPref("sobidogam:monthStartDay") ?? "1");
	return Number.isInteger(value) && value >= 1 && value <= 28 ? value : 1;
}
